/* eslint-disable import/prefer-default-export */
import PT from 'prop-types'

export const TypeStoryLink = PT.shape({
  id: PT.string,
  url: PT.string,
  linktype: PT.string,
  fieldtype: PT.string,
  cached_url: PT.string,
})

// TODO: These are the actual fields from storyblok
// cached_url: PT.string,
// fieldtype: PT.string,
// id: PT.string,
// linktype: PT.string,
export const TypeLink = PT.shape({
  url: PT.string,
  title: PT.string,
  isDisabled: PT.bool,
  links: PT.arrayOf(
    PT.shape({
      url: PT.string,
      title: PT.string,
      isDisabled: PT.bool,
    })
  ),
})

const nodeShape = {
  type: PT.string,
  content: PT.arrayOf(this),
}

export const TypeRichTextField = PT.shape({
  data: PT.shape(nodeShape),
})

export const cardType = {
  component: PT.string,
  description: TypeRichTextField,
  descriptionTitle: PT.string,
  videoUrl: TypeStoryLink,
  image: PT.string,
  imageAltText: PT.string,
  isReversed: PT.bool,
  hasStars: PT.bool,
  is169Ratio: PT.bool,
  layoutDirection: PT.oneOf(['portrait', 'landscape', 'undefined']),
  primaryButtonLink: TypeStoryLink,
  primaryButtonText: PT.string,
  primaryButtonTarget: PT.string,
  primaryButtonColor: PT.string,
  secondaryButtonLink: TypeStoryLink,
  secondaryButtonText: PT.string,
  secondaryButtonTarget: PT.string,
  subTitle: TypeRichTextField,
  titleSize: PT.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p']),
  title: PT.string,
  _editable: PT.string,
  _uid: PT.string,
}

export const productCardType = {
  component: PT.string,
  description: TypeRichTextField,
  descriptionTitle: PT.string,
  image: PT.string,
  imageAltText: PT.string,
  isReversed: PT.bool,
  hasStars: PT.bool,
  is169Ratio: PT.bool,
  layoutDirection: PT.oneOf(['portrait', 'landscape', 'undefined']),
  primaryButtonLink: TypeStoryLink,
  primaryButtonTarget: PT.string,
  primaryButtonText: PT.string,
  primaryButtonColor: PT.string,
  secondaryButtonLink: TypeStoryLink,
  secondaryButtonText: PT.string,
  secondaryButtonTarget: PT.string,
  title: PT.string,
  _editable: PT.string,
  _uid: PT.string,
  subtitleText: TypeRichTextField,
  price: PT.string,
  onceOffText: PT.string,
  weeklyText: PT.string,
}

export const TypeCard = PT.shape(cardType)

export const TypeColorOptions = PT.oneOf(['white', 'black', 'grey'])

export const TypePressReleasePreview = {
  description: TypeRichTextField,
  dateTime: PT.string,
  downloadLink: PT.string,
  primaryMediaLink: PT.string,
}



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/utils/types.js